import { Injectable } from '@angular/core';
import { AppConfig } from '@core_n/app.config';
import { Observable, Subject } from 'rxjs';

export interface DragPayload<T = any>{
    type: string;
    data: T;
}

@Injectable({
    providedIn: 'root'
})

export class DndBusService{
    // videoPlayer = AppConfig.settings.videoAddress.videoPlayer;

    private readonly _dragStart$ = new Subject<DragPayload>();
    private readonly _dragEnd$ = new Subject<void>();

    dragStart(payload: DragPayload) {
        this._dragStart$.next(payload);
    }
    dragEnd() {
        this._dragEnd$.next();
    }

    getSlotId(index: number){
        return `player${index}`;
      }

    get dragStart$(): Observable<DragPayload> { return this._dragStart$.asObservable(); }
    get dragEnd$(): Observable<void> { return this._dragEnd$.asObservable(); }
}

